import React, { useContext, useEffect, useState } from "react";
import ProfileC from "./DashNavbar.module.css";
import UserContext from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import MemberShipPlan from "./NewHomePage/MemberShipPlan"; // Import the MemberShipPlan component

function DashNavbar({ showPopup, handleAddToHomeScreen }) {
  const { userDetail } = useContext(UserContext);
  const navigate = useNavigate();

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 980);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 980);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("flag");
    navigate("/");
    window.location.reload();
  };

  // Handler to open the modal
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  // Handler to close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={ProfileC.loggedInUserNavMain}>
      <div className={ProfileC.loggedInUserNav}>
        {userDetail?.is_trial_active && (
          <button onClick={handleOpenModal} className={ProfileC.joinGameBtn}>
            Join Now
          </button>
        )}
        <p className={ProfileC.loggedInUserName}>
          {userDetail && <p>{userDetail.user_name}</p>}
        </p>
        {showPopup && isMobileView && (
          <div onClick={handleAddToHomeScreen}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 56 73"
              fill="#ffb000"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.591 11.8068C14.7123 12.6855 14.7123 14.1101 15.591 14.9888C16.4697 15.8675 17.8943 15.8675 18.773 14.9888L26 7.76178V45.1971C26 46.4398 27.0074 47.4471 28.25 47.4471C29.4926 47.4471 30.5 46.4398 30.5 45.1971V7.48272L37.7832 14.7659C38.6619 15.6446 40.0865 15.6446 40.9652 14.7659C41.8439 13.8873 41.8439 12.4626 40.9652 11.584L30.1965 0.815221C30.0099 0.62864 29.7987 0.481678 29.5733 0.374336C28.6995 -0.206342 27.5093 -0.11145 26.7388 0.65901L15.591 11.8068Z"
                strokeWidth="4"
              ></path>
              <path
                d="M8 20.4471H19V24.9471H8C6.067 24.9471 4.5 26.5141 4.5 28.4471V64.4471C4.5 66.3801 6.067 67.9471 8 67.9471H48C49.933 67.9471 51.5 66.3801 51.5 64.4471V28.4471C51.5 26.5141 49.933 24.9471 48 24.9471H38V20.4471H48C52.4183 20.4471 56 24.0289 56 28.4471V64.4471C56 68.8654 52.4183 72.4471 48 72.4471H8C3.58172 72.4471 0 68.8654 0 64.4471V28.4471C0 24.0289 3.58172 20.4471 8 20.4471Z"
                strokeWidth="4"
              ></path>
            </svg>
          </div>
        )}
      </div>
      {/* Conditionally render the MemberShipPlan modal */}
      {isModalOpen && (
        <MemberShipPlan onClose={handleCloseModal} userDetail={userDetail} />
      )}
    </div>
  );
}

export default DashNavbar;
